import * as THREE from 'three';
import { InteractiveStar } from './InteractiveStar.js';

const SKY_RADIUS = 800;

function azAlt(azDeg, altDeg) {
  const az = (azDeg * Math.PI) / 180;
  const alt = (altDeg * Math.PI) / 180;
  const cosAlt = Math.cos(alt);
  return new THREE.Vector3(
    SKY_RADIUS * cosAlt * Math.sin(az),
    SKY_RADIUS * Math.sin(alt),
    -SKY_RADIUS * cosAlt * Math.cos(az),
  );
}

const PULSAR_CARD = `
  <h2>The Pulsar</h2>
  <div class="label">Dance - Classical and Western</div>

  <p>This star spins.</p>

  <p>It is called a pulsar. It is a neutron star - a sun that collapsed under its own weight and got so dense that a teaspoon of it would weigh a billion tonnes. When it formed, it started spinning. It has been spinning ever since. Faster than anything else in the sky.</p>

  <p>Every time it turns, it sends out a beat.</p>

  <p>That is what astronomers detect when they find one. Not light. Rhythm.</p>

  <hr>

  <p>You learned to dance when you were small. Mohiniattam first - graceful, slow, fluid. Then Bharatnatyam - precise, rhythmic, grounded. Two classical forms. Two ways of telling a story with your body before you had the words for it.</p>

  <p>That was years ago. Recently, you started a different dance. Salsa. Different country, different music, different costume.</p>

  <p>Same beating heart.</p>

  <hr>

  <p>You have always been a person who moves to music. You are still becoming that person.</p>

  <p>Astronomers sometimes describe pulsars as the lighthouses of the universe.</p>

  <p>They are wrong.</p>

  <p>They are dancers.</p>
`;

/**
 * Pulsar - the dance star.
 *
 * Visually distinct from every other interactive star: a cool blue-white
 * sprite with a STRONG, FAST pulse (much bigger amplitude and frequency
 * than the gentle pulses on Sirius/BirthStar/family). The rhythm is
 * literal - that's what a pulsar IS.
 *
 * The cool blue-white color is astronomically true (real pulsars are
 * extremely hot neutron stars), and it makes the pulsar visually
 * recognizable as "different" from the warm gold of other stars.
 *
 * Position: south sky high, in a quiet area away from other interactive
 * objects. The visitor sees a pulsing dot and is drawn to it.
 */
export function createPulsar({ onClick }) {
  return new InteractiveStar({
    position: azAlt(180, 65),
    color: 0x88c8ff,
    glowColor: '136, 200, 255',
    scale: 30,
    pulseSpeed: 7.0,    // visibly fast - about 1.1 Hz
    pulseAmount: 0.25,  // strong amplitude - clearly pulsing
    discoveryId: 'pulsar',
    category: 'hobbies',
    cardHTML: PULSAR_CARD,
    onClick,
  });
}
